import React from "react"
import { Link } from "gatsby"
import * as Icon from "react-feather"

const OurFeatures = () => {
  return (
    <>
      <div className="features-area pt-80 pb-50 bg-f7fafd">
        <div className="container">
          <div className="section-title">
            <h2>Why Choose Codemobx</h2>
            <div className="bar"></div>
            <p>
              At Codemobx, we combine modern technology, clean architecture,
              and business-focused solutions to deliver high-performance
              web and mobile applications.
            </p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-6">
              <div className="single-features">
                <div className="icon">
                  <Icon.Settings />
                </div>
                <h3>
                  <Link to="/feature-details">Scalable Architecture</Link>
                </h3>
                <p>
                  We design systems built to scale, ensuring long-term performance and stability.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="single-features">
                <div className="icon">
                  <Icon.Mail />
                </div>
                <h3>
                  <Link to="/feature-details">Reliable Communication</Link>
                </h3>
                <p>
                  Transparent updates and consistent communication throughout the development process.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="single-features">
                <div className="icon bg-c679e3">
                  <Icon.Grid />
                </div>
                <h3>
                  <Link to="/feature-details">Modern Tech Stack</Link>
                </h3>
                <p>
                  We use cutting-edge frameworks and tools for efficient and future-ready solutions.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="single-features">
                <div className="icon bg-c679e3">
                  <Icon.Info />
                </div>
                <h3>
                  <Link to="/feature-details">Data-Driven Development</Link>
                </h3>
                <p>
                  Every solution is optimized using analytics, performance insights, and best practices.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="single-features">
                <div className="icon bg-eb6b3d">
                  <Icon.Box />
                </div>
                <h3>
                  <Link to="/feature-details">Custom Solutions</Link>
                </h3>
                <p>
                  Tailored web and app solutions designed to match unique business requirements.
                </p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="single-features">
                <div className="icon bg-eb6b3d">
                  <Icon.Bell />
                </div>
                <h3>
                  <Link to="/feature-details">On-Time Delivery</Link>
                </h3>
                <p>
                  Structured workflows and agile practices ensure timely project completion.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OurFeatures